import React, { createContext, useContext, useState } from 'react';

import unionBy from 'lodash/unionBy';

import { IssueTestType } from '@qality/common-model/src/TestType';

export type TestCaseRepositoryIssueTypesContextValue = {
  testCasesTestTypes: Array<IssueTestType>;
  updateTestCasesTestTypes: (issuesToUpdate: Array<IssueTestType>) => void;
};

export const initialContextValue: TestCaseRepositoryIssueTypesContextValue = {
  testCasesTestTypes: [],
  updateTestCasesTestTypes: () => undefined,
};

export const TestCaseRepositoryIssueTypesContext =
  createContext<TestCaseRepositoryIssueTypesContextValue>(initialContextValue);

export const useTestCaseRepositoryIssueTypesContext =
  (): TestCaseRepositoryIssueTypesContextValue => {
    return useContext(TestCaseRepositoryIssueTypesContext);
  };

type Props = { children: React.ReactNode };

export function TestCaseRepositoryIssueTypesProvider({
  children,
}: Props): JSX.Element {
  const [testCasesTestTypes, setTestCasesTestTypes] = useState<
    Array<IssueTestType>
  >([]);

  const updateTestCasesTestTypes = (issuesToUpdate: Array<IssueTestType>) => {
    setTestCasesTestTypes((prevState) => {
      const result = unionBy(
        issuesToUpdate,
        prevState,
        (item: IssueTestType) => item.testCaseId
      );

      return result;
    });
  };

  return (
    <TestCaseRepositoryIssueTypesContext.Provider
      value={{
        testCasesTestTypes,
        updateTestCasesTestTypes,
      }}
    >
      {children}
    </TestCaseRepositoryIssueTypesContext.Provider>
  );
}
